// to avoid circlular dependencies, this is in a separate file
export const iconClassName =
    'group-hover:scale-105 transition-transform fill-giphyLightestGrey group-hover:fill-giphyWhite'
